export const isBrowser: boolean = (process as any).browser;
export const isServer: boolean = !isBrowser;
